var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	(function(linkTag) {
	                if (typeof _N_E_STYLE_LOAD === 'function') {
	                    const { href, onload, onerror } = linkTag;
	                    _N_E_STYLE_LOAD(href.indexOf(window.location.origin) === 0 ? new URL(href).pathname : href).then(()=>onload == null ? void 0 : onload.call(linkTag, {
	                            type: 'load'
	                        }), ()=>onerror == null ? void 0 : onerror.call(linkTag, {}));
	                } else {
	                    document.head.appendChild(linkTag);
	                }
	            })(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	8068: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"130":1,"336":1,"486":1,"490":1,"542":1,"550":1,"568":1,"670":1,"749":1,"768":1,"845":1,"1002":1,"1022":1,"1042":1,"1074":1,"1163":1,"1196":1,"1197":1,"1257":1,"1380":1,"1588":1,"1661":1,"1750":1,"1810":1,"1861":1,"1944":1,"2018":1,"2025":1,"2030":1,"2041":1,"2084":1,"2086":1,"2194":1,"2294":1,"2387":1,"2484":1,"2546":1,"2606":1,"2649":1,"2657":1,"2679":1,"2809":1,"2864":1,"2924":1,"2954":1,"3004":1,"3059":1,"3098":1,"3191":1,"3212":1,"3226":1,"3248":1,"3546":1,"3655":1,"3666":1,"3731":1,"3745":1,"3749":1,"3777":1,"3784":1,"3934":1,"3942":1,"4150":1,"4205":1,"4328":1,"4361":1,"4526":1,"4557":1,"4621":1,"4628":1,"4644":1,"4663":1,"4703":1,"4756":1,"4822":1,"5128":1,"5209":1,"5382":1,"5446":1,"5464":1,"5510":1,"5535":1,"5763":1,"5805":1,"5967":1,"5994":1,"6082":1,"6146":1,"6178":1,"6255":1,"6308":1,"6387":1,"6411":1,"6447":1,"6467":1,"6472":1,"6613":1,"6716":1,"6769":1,"6782":1,"6806":1,"6850":1,"6879":1,"7024":1,"7180":1,"7213":1,"7380":1,"7408":1,"7590":1,"7596":1,"7716":1,"7780":1,"7790":1,"7801":1,"7878":1,"7968":1,"7994":1,"8060":1,"8153":1,"8177":1,"8206":1,"8269":1,"8294":1,"8438":1,"8574":1,"8594":1,"8634":1,"8673":1,"8721":1,"8904":1,"8934":1,"8978":1,"9030":1,"9052":1,"9202":1,"9329":1,"9347":1,"9607":1,"9624":1,"9668":1,"9838":1,"9846":1,"9854":1,"9910":1,"9931":1,"9934":1,"9969":1,"9976":1,"9983":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr